import { mySort } from "../../util/util";

export const suggestMap = {
    "init": function (suggest, asyncService, authService, GyCtrl) {
        return new Promise((resolve) => {
            let code = '';
            let name = '';
            let item = '';
            switch (suggest) {
                case 'maker':
                    code = 'mekacd';
                    name = 'mekasskimei';
                    item = 'maker';
                    break;
                case 'tokuisaki':
                    code = 'tksakicd';
                    name = 'tksakiryakumei';
                    item = 'tksaki';
                    break;
                case 'siresaki':
                    code = 'sirskicd';
                    name = 'sirskisskimei';
                    item = 'sirski';
                    break;
                case 'init':
                    code = 'shincd';
                    name = 'shinsskimei';
                    item = 'shin';
                    break;
                default:
                    break;
            }
            // メーカマスタ検索
            // TODO
            // const params = { "knskmasta": kubunmap.JKENKBN.MEKACD.code, "bmncd": authService.getUser().kngnlv2 };
            const params = null;
            asyncService.async(GyCtrl.selectSuggetInfo(params), function (result) {
                // データを取得できなかった場合、終了する
                if (!result.data) {
                    return;
                }

                let label = '';
                let search = '';
                let dataList = [];
                let maxSugget = 5;
                let fieldsOrder = [];


                for (let i = 1; i <= maxSugget; i++) {
                    if (result.data[('suggestitem' + i)]) {
                        fieldsOrder.push(result.data[('suggestitem' + i)].toLowerCase());
                    }
                }
                const datas = mySort(result.data, fieldsOrder);
                for (let i = 0; i < datas.length; i++) {
                    label = datas[i][code] + ':' + datas[i][name];
                    search = '';
                    for (let j = 1; j <= maxSugget; j++) {
                        if (result.data[('suggestitem' + j)]
                            && Object.keys(datas[i]).indexOf(result.data[('suggestitem' + j)].toLowerCase()) >= 0) {
                            search += datas[i][result.data[('suggestitem' + j)].toLowerCase()];
                        }
                    }
                    dataList.push({ 'search': search, 'value': datas[i][code], 'label': label });
                }
                // サジェスト対象項目リストにデータを反映する
                resolve(dataList);
            });
        })

    }
}

export default suggestMap;